<template>
    <div class="MobileHeader">
        <div class="left">
            <slot name="arrowLeft"></slot>

        </div>
        <div class="text">
            <slot name="title"></slot>

        </div>
        <div class="right">
            <slot name="button"></slot>

        </div>
    </div>
</template>

<script>
export default {
    name: 'MobileHeader',
    data() {
        return {
            // data properties
        }
    },
    mounted() {
        // lifecycle hook
    },
    methods: {
        // methods
    }
}
</script>

<style lang="scss" scoped>
.MobileHeader {
    /* styles */
    margin-bottom: 15px;
    padding: 5px 0 8px;
    font-size: clamp(16px, 0.18rem, 18px);
    line-height: 38px;
    text-align: center;
    position: relative;

    .left {
        position: absolute;
        top: 5px;
        left: 0;
        font-size: 20px;
        line-height: 38px;
    }
    .right {
        position: absolute;
        top: 3px;
        right: 10px;
        line-height: 38px;
        border-radius: 5px;
        .button {
            padding: 5px 8px;
            font-size: 14px;
            background-color: var(--collapse-bg-color);
            border-radius: 3px;
        }
    }
}
</style>